// Buyer-intent English keyword clusters for every main service discipline + its sub-services.
// Mirrors the land-surveying keyword coverage (CORE_CLUSTERS) across the rest of the catalogue.
// Each keyword links to its /services/<slug> page. Used by ServiceDetail pages + FooterSeoBand.

export const DISCIPLINE_KEYWORDS = [
  {
    id: 'bim-digital',
    name: 'BIM & Digital',
    services: [
      {
        slug: 'bim-services', title: 'BIM Services',
        keywords: [
          'outsourced BIM modeling services', 'scan to BIM services', 'BIM clash detection services',
          'Revit family creation services', '4D BIM scheduling services', '5D BIM cost estimation',
          'BIM coordination services', 'LOD 300 BIM modeling', 'LOD 400 BIM modeling',
          'BIM execution plan consultants', 'point cloud to BIM conversion', 'as-built BIM modeling services',
          'architectural BIM services', 'structural BIM modeling', 'MEP BIM coordination services'
        ]
      },
      {
        slug: '3d-modeling', title: '3D Modeling',
        keywords: [
          '3D modeling services', 'architectural 3D modeling services', 'photorealistic 3D rendering',
          '3D product modeling services', 'real estate 3D walkthroughs', 'virtual tour creation services',
          '3D visualization company', 'CAD to 3D model conversion', '3D printing file preparation',
          'outsourced 3D modeling company', 'SketchUp modeling services', '3ds Max modeling services'
        ]
      },
      {
        slug: 'gis-geospatial', title: 'GIS & Geospatial',
        keywords: [
          'GIS mapping services', 'ArcGIS mapping services', 'LiDAR data processing services',
          'drone mapping services', 'geospatial data conversion', 'cadastral GIS mapping',
          'utility GIS mapping services', 'GIS data digitization', 'smart city GIS services',
          'asset GIS mapping', 'CAD to GIS conversion services', 'parcel mapping services'
        ]
      }
    ]
  },
  {
    id: 'building-services',
    name: 'Building Services',
    services: [
      {
        slug: 'steel-detailing', title: 'Steel Detailing',
        keywords: [
          'structural steel detailing services', 'steel shop drawing services', 'steel erection drawings',
          'steel connection design services', 'miscellaneous steel detailing', 'stair and railing detailing',
          'anchor bolt plan drafting', 'Tekla steel detailing services', 'rebar detailing services',
          'outsourced steel detailing company', 'AISC steel detailing', 'steel fabrication drawings'
        ]
      },
      {
        slug: 'structural-engineering', title: 'Structural Engineering',
        keywords: [
          'structural engineering services', 'structural drafting services', 'foundation design services',
          'seismic analysis services', 'steel and concrete design', 'retaining wall design services',
          'structural CAD drafting company', 'bridge engineering services', 'structural analysis outsourcing',
          'industrial structure design', 'structural shop drawings', 'outsourced structural design services'
        ]
      },
      {
        slug: 'mep-engineering', title: 'MEP Engineering',
        keywords: [
          'MEP engineering services', 'MEP drafting services', 'HVAC design services',
          'electrical design and drafting', 'plumbing design services', 'fire protection design services',
          'MEP shop drawings', 'MEP coordination services', 'outsourced MEP design company',
          'building automation design', 'energy modeling services', 'LEED compliance consulting'
        ]
      },
      {
        slug: 'engineering-designs', title: 'Engineering Designs',
        keywords: [
          'engineering design services', 'concept design services', 'feasibility study services',
          'schematic design services', 'design development drawings', 'construction document services',
          'engineering calculation services', 'outsourced engineering design company', 'CAD design services',
          'engineering drafting outsourcing', 'design documentation services', 'technical specification writing'
        ]
      },
      {
        slug: 'facility-management', title: 'Building Facility Management',
        keywords: [
          'facility management drawings', 'FM-ready BIM services', 'COBie data services',
          'asset tagging services', 'space utilization studies', 'CAFM integration services',
          'O&M documentation services', 'building lifecycle costing', 'as-built facility drawings',
          'preventive maintenance documentation', 'facility CAD services', 'digital twin for facilities'
        ]
      }
    ]
  },
  {
    id: 'construction',
    name: 'Construction',
    services: [
      {
        slug: 'construction-engineering', title: 'Construction Engineering',
        keywords: [
          'construction drawing services', 'construction documentation services', 'permit drawing services',
          'shop drawing review services', 'as-built drawing services', 'quantity takeoff services',
          'constructability review services', 'site coordination drawings', 'construction CAD drafting company',
          'outsourced construction drafting', 'IFC drawing production', 'RFI support services'
        ]
      },
      {
        slug: 'architectural', title: 'Architectural Services',
        keywords: [
          'architectural drafting services', 'architectural CAD drafting company', 'floor plan drafting services',
          'elevation and section drawings', 'permit drawing preparation', 'construction documentation services',
          'space planning services', 'measured building survey drawings', 'outsourced architectural drafting',
          'residential drafting services', 'commercial architectural drafting', 'interior design drafting'
        ]
      },
      {
        slug: 'lumber-millwork', title: 'Lumber & Millwork',
        keywords: [
          'millwork shop drawing services', 'casework shop drawings', 'cabinetry detailing services',
          'custom millwork drafting', 'lumber takeoff services', 'architectural woodwork drawings',
          'CNC-ready DXF file preparation', 'AWI millwork drawings', 'engineered wood framing design',
          'woodwork drafting outsourcing', 'furniture shop drawings', 'joinery detailing services'
        ]
      },
      {
        slug: 'rendering-animation', title: 'Rendering & Animation',
        keywords: [
          'architectural rendering services', 'photorealistic exterior rendering', 'interior visualization services',
          '3D walkthrough animation', '360 VR tour creation', 'construction sequence animation',
          'product 3D animation services', 'real-time visualization services', 'Lumion rendering services',
          'Twinmotion visualization', 'outsourced rendering company', 'real estate rendering services'
        ]
      },
      {
        slug: 'graphics-services', title: 'Graphics & Creative',
        keywords: [
          'graphic design outsourcing', 'marketing visual design services', 'product visualization services',
          'illustration services', 'architectural illustration', '3D graphics services',
          'creative design studio services', 'branding visual services', 'technical illustration services'
        ]
      },
      {
        slug: 'premedia-services', title: 'Premedia Services',
        keywords: [
          'premedia services', 'prepress production services', 'image retouching services',
          'color management services', 'CMYK conversion services', 'digital asset preparation',
          'high-resolution scan correction', 'soft proofing services', 'print production outsourcing'
        ]
      },
      {
        slug: 'publishing-services', title: 'Publishing & Print',
        keywords: [
          'publishing services outsourcing', 'page layout and typesetting', 'eBook conversion services',
          'ePub conversion services', 'print-ready PDF services', 'magazine layout design',
          'textbook layout services', 'XML-first publishing services', 'PDF accessibility remediation'
        ]
      }
    ]
  },
  {
    id: 'manufacturing',
    name: 'Manufacturing',
    services: [
      {
        slug: 'manufacturing', title: 'Manufacturing Engineering',
        keywords: [
          'manufacturing engineering services', 'CNC programming services', 'tooling design services',
          'jig and fixture design', 'CAM programming services', 'process planning services',
          'production drawing services', 'manufacturing CAD services', 'quality engineering support',
          'outsourced manufacturing design', 'DFM analysis services', 'mechanical drafting for manufacturing'
        ]
      },
      {
        slug: 'mechanical-engineering', title: 'Mechanical Engineering',
        keywords: [
          'mechanical engineering services', 'mechanical CAD drafting services', 'HVAC drafting services',
          'sheet metal design services', 'piping design and drafting', 'mechanical 3D modeling',
          'SolidWorks design services', 'Inventor design services', 'mechanical shop drawings',
          'outsourced mechanical design company', 'machine design services', 'mechanical calculation services'
        ]
      }
    ]
  },
  {
    id: 'industrial',
    name: 'Industrial',
    services: [
      {
        slug: 'plant-engineering', title: 'Plant Engineering',
        keywords: [
          'plant engineering services', 'plant layout design services', '3D plant modeling services',
          'piping design services', 'P&ID drafting services', 'AutoCAD Plant 3D services',
          'SmartPlant SP3D modeling', 'equipment layout drawings', 'plant CAD drafting company',
          'isometric drawing services', 'outsourced plant design services', 'brownfield plant modeling'
        ]
      },
      {
        slug: 'process-equipment', title: 'Process Equipment Design',
        keywords: [
          'process equipment design services', 'pressure vessel design services', 'storage tank design',
          'heat exchanger design services', 'PV Elite analysis services', 'ASME code compliance design',
          'skid package engineering', 'reactor design services', 'equipment fabrication drawings',
          'vessel GA drawing services', 'process skid design', 'API 650 tank design'
        ]
      },
      {
        slug: 'oil-gas-energy', title: 'Oil, Gas, LNG & Energy',
        keywords: [
          'oil and gas engineering services', 'LNG facility design services', 'refinery engineering support',
          'power plant design services', 'solar plant engineering services', 'wind farm layout design',
          'offshore platform engineering', 'renewable energy infrastructure design', 'pipeline drafting services',
          'energy sector CAD services', 'substation design drafting', 'oil and gas drafting outsourcing'
        ]
      },
      {
        slug: 'signage-engineering', title: 'Signage Engineering',
        keywords: [
          'signage engineering services', 'channel letter design services', 'LED sign design services',
          'ADA compliant signage design', 'wayfinding signage design', 'digital signage engineering',
          'sign permit drawings', 'sign fabrication drawings', 'LED Wizard design services',
          'signage CAD drafting company', 'monument sign design', 'pylon sign engineering'
        ]
      }
    ]
  },
  {
    id: 'environmental',
    name: 'Environmental',
    services: [
      {
        slug: 'environmental-engineering', title: 'Environmental Engineering',
        keywords: [
          'environmental engineering services', 'water treatment plant design', 'wastewater treatment design',
          'solid waste management design', 'air quality engineering services', 'renewable energy design services',
          'hydrogeology study support', 'environmental impact assessment support', 'environmental CAD drafting',
          'remediation design services', 'environmental permitting drawings', 'sustainability engineering services'
        ]
      },
      {
        slug: 'water-wastewater', title: 'Water & Drainage',
        keywords: [
          'water and drainage engineering', 'stormwater drainage design services', 'sewer system design services',
          'water supply network design', 'hydraulic modeling services', 'HEC-RAS modeling services',
          'pump station design services', 'detention basin design', 'drainage CAD drafting services',
          'stormwater management plans', 'culvert design services', 'flood study modeling support'
        ]
      }
    ]
  }
];

export const keywordsForService = (slug) => {
  for (const d of DISCIPLINE_KEYWORDS) {
    const s = d.services.find(x => x.slug === slug);
    if (s) return s.keywords;
  }
  return [];
};
